import { render, staticRenderFns } from "./BuildCodingTest.vue?vue&type=template&id=02826ede"
import script from "./BuildCodingTest.vue?vue&type=script&lang=js"
export * from "./BuildCodingTest.vue?vue&type=script&lang=js"
import style0 from "./BuildCodingTest.vue?vue&type=style&index=0&id=02826ede&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports